import InsideHeaderNav from "./Horizontal/InsideHeaderNav";

const AppLayouts = {
  InsideHeaderNav
};
export default AppLayouts;
